import {Injectable} from "@angular/core";
import {BaseApi} from "./baseService";
import {Http, RequestOptions} from "@angular/http";
import {ConfigService} from "./configService";
import {BaseResponse} from "../objects/common/baseResponse";
import {RNSStatusModel} from "../objects/pars-status-widget/RNS-status-model";

@Injectable()
export class RNSService extends BaseApi{
    constructor(http: Http, configService: ConfigService) {
        super(http, configService);
    }

    public CheckCCN(ccnNumber: string): Promise<BaseResponse<RNSStatusModel>>{
        return this.get(new RequestOptions({
            url: `status/RNSStatus/${ccnNumber}`
        }));
    }
    
    public refreshStatus(statusQueryId: number): Promise<BaseResponse<Object>>{
        return this.get(new RequestOptions({
            url: `status/RNSStatus/${statusQueryId}/refresh`
        }));
    }
}


// WEBPACK FOOTER //
// ./app/services/RNS.service.ts